import {
  getCubesByProjectId,
  getSurvey2dsByProjectId,
  selectActiveTree,
  selectProjectCubes,
  selectProjectSurveys,
  useAppDispatch,
  useAppSelector,
} from '@core/core/store'
import type { CubeBriefInfo, Survey2dInfo } from '@core/core/types'
import type { ProjectId } from 'common/types'
import { useEffect } from 'react'

export const useGetSurveyItems = (
  activeProjectId: ProjectId,
): {
  survey2DItems: Survey2dInfo[]
  survey3DItems: CubeBriefInfo[]
} => {
  const dispatch = useAppDispatch()
  const survey2DItems = useAppSelector(selectProjectSurveys)
  const survey3DItems = useAppSelector(selectProjectCubes)
  const activeTree = useAppSelector(selectActiveTree)

  useEffect(() => {
    dispatch(getSurvey2dsByProjectId(activeProjectId))
    dispatch(getCubesByProjectId(activeProjectId))
  }, [activeTree])

  return { survey2DItems, survey3DItems }
}
